import { Pipe, PipeTransform } from '@angular/core';
import { isNotBlank } from '@app/utils/string';

@Pipe({
  name: 'notBlank',
  pure: true,
  standalone: false,
})
export class NotBlankPipe implements PipeTransform {
  transform(value: string): boolean {
    return isNotBlank(value);
  }
}
